module.exports = __webpack_public_path__ + "static/media/ThumbsDown.ace6d37d.png";